import { gql } from "@apollo/client";export default gql`mutation DeleteSetCollection($ids: [Int!]) {
    delete_set_collection(where: { id: { _in: $ids } }) {
        affected_rows
    }
}
`;
